import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { color } from '../../templates/Ui';
import { StyledInput as _StyledInput } from '../FilterInput';
import Cross from '../icons/Cross';
import InputLabel from '../labels/InputLabel';
const StyledContainer = styled.div `
    position: relative;
`;
const StyledInput = styled(_StyledInput) `
    &:not([value='']) {
        padding-right: 40px;
    }
`;
const StyledClearButton = styled.button `
    position: absolute;
    top: 41px;
    right: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e4e4e4;
    border: none;
    border-radius: 50%;
    width: 22px;
    height: 22px;
    transition: all 150ms ease-in-out;
    cursor: pointer;

    &:hover {
        .icon--cross {
            fill: ${color.error.base};
        }
    }
`;
const StyledCross = styled(Cross) `
    fill: #5d5d5d;
    width: 8px;
    height: 8px;
    transition: all 150ms ease-in-out;
`;
export const FilterInput = ({ label, name, onClear, ...props }) => {
    const inputRef = React.useRef(null);
    const handleClear = () => {
        if (inputRef.current) {
            inputRef.current.value = '';
            inputRef.current.focus();
        }
        if (onClear) {
            onClear(name)();
        }
    };
    return (_jsxs(StyledContainer, { "data-testid": "filter-input", children: [_jsx(InputLabel, { "data-testid": "filter-input__label", htmlFor: name, marginBottom: "6px", activeFilter: Boolean(props.value), children: label }), _jsx(StyledInput, { "data-testid": "filter-input__input", name: name, ref: inputRef, ...props }), props.value && (_jsx(StyledClearButton, { "data-testid": "filter-input__clear-button", type: 'button', onClick: handleClear, children: _jsx(StyledCross, { className: "icon--cross" }) }))] }));
};
